import { t } from 'ember-intl';
import type EmployeeModel from 'tio-data/models/employee';
import AccountsLinkedAccountsCard from 'tio-employee/components/accounts/linked-accounts-card';
import RecommendationsDashRecommendations from 'tio-employee/components/recommendations/dash-recommendations';
import RecommendationsDashResults from 'tio-employee/components/recommendations/dash-results';
import RecommendationsMonthlyPaymentForgivenessCard from 'tio-employee/components/recommendations/monthly-payment-forgiveness-card';
import { HStack, VStack } from 'tio-reimagined/components/layout';
import type { TOC } from '@ember/component/template-only';

interface S {
  Args: {
    model: EmployeeModel;
  };
}

const tmpl: TOC<S> = <template>
  <HStack>
    <VStack>
      <AccountsLinkedAccountsCard
        @accounts={{@model.accounts}}
        {{! @glint-expect-error: seems like a bug to me}}
        @loanSummary={{@model.loanSummary}}
        @person={{@model.person}}
        @programName={{t "dashboard_tiles.income_driven_repayment"}}
        @source="idr"
        @providers="nslds"
      />
      <RecommendationsDashRecommendations
        class="grow"
        {{! @glint-expect-error: seems like a bug to me}}
        @loanSummary={{@model.loanSummary}}
        @person={{@model.person}}
        {{! @glint-expect-error: seems like a bug to me}}
        @recommendation={{@model.mostRecentRecommendation}}
        @source="idr"
      />
    </VStack>
  </HStack>
  {{! @glint-expect-error: seems like a bug to me}}
  {{#if @model.mostRecentRecommendation}}
    <RecommendationsDashResults
      {{! @glint-expect-error: seems like a bug to me}}
      @allRecommendations={{@model.allRecommendations}}
      @accounts={{@model.accounts}}
      {{! @glint-expect-error: seems like a bug to me}}
      @loanSummary={{@model.loanSummary}}
      @person={{@model.person}}
      @programType="idr"
      {{! @glint-expect-error: seems like a bug to me}}
      @recommendation={{@model.mostRecentRecommendation}}
    />
  {{else}}
    <RecommendationsMonthlyPaymentForgivenessCard
      @accounts={{@model.accounts}}
      {{! @glint-expect-error: seems like a bug to me}}
      @loanSummary={{@model.loanSummary}}
      @person={{@model.person}}
      @programType="idr"
      @user={{@model.user}}
      @isCanceling={{false}}
    />
  {{/if}}
</template>;

export default tmpl;
